import { CSSProperties, DetailedHTMLProps, HTMLAttributes } from 'react';
import { components, GroupBase, MenuListProps } from 'react-select';
import { SelectLoadingOptionsIndicator } from './SelectLoadingOptionsIndicator';
import { OptionList } from './Select.styles';
import { BaseOption } from './types';

export const BaseSelectMenuList = (
  props: MenuListProps<BaseOption<string>, boolean, GroupBase<BaseOption<string>>> & {
    containerStyles?: CSSProperties;
  },
) => {
  const isLoadingOptions = props.selectProps.isLoading;
  return (
    <components.MenuList
      {...props}
      innerProps={
        { 'data-test': 'select-menu-list', ...props.innerProps } as DetailedHTMLProps<
          HTMLAttributes<HTMLDivElement>,
          HTMLDivElement
        >
      }
    >
      <OptionList style={props.containerStyles} data-test="select-option-list">
        {props.children}
      </OptionList>
      {isLoadingOptions && <SelectLoadingOptionsIndicator />}
    </components.MenuList>
  );
};

export const SelectMenuList = BaseSelectMenuList;
